import { BudgetPhases } from 'business/constants';
import _ from 'lodash';
import { StatusesSettingsT } from 'routes/BudgetModule/config/types';
import { getFieldForPhase } from '../shared/phases/helpers';

/** Remove unknown inscription */
const removeUnknown = (
    inscription: FlowAnyObject,
    amountField: string,
): boolean =>
    inscription[amountField] && inscription[amountField] !== 'unknown';

/** Retrieve the amount aggregated for a given inscription */
export const getAggAmount = (
    amountField: string,
    inscriptions: FlowAnyObject,
    phase: BudgetPhases,
    statusesSettings: StatusesSettingsT,
): number =>
    _(inscriptions)
        .filter((inscription) => removeUnknown(inscription, amountField))
        .filter(
            (inscription) =>
                !getFieldForPhase(phase, 'isInscriptionRejected')(
                    inscription,
                    statusesSettings,
                ),
        )
        .sumBy(amountField);
